import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from "@sentry/angular";
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import environment from './environments/environment';

if (environment.sentryDsn) {
  Sentry.init({
    dsn: environment.sentryDsn,
    
    environment: environment.envName || 'development', 
    
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    
    sendDefaultPii: true,
  });
}

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));